import { Link, Outlet } from 'react-router-dom'
import { useTheme } from '../../app/ThemeContext'
import { appConfig } from '../../config/app'
import { usePublicSettings } from '../../features/settings/usePublicSettings'

export default function AuthLayout() {
  const { resolvedTheme, setMode } = useTheme()
  const {data:branding}=usePublicSettings()

  return (
    <div className="auth-shell healthcare-auth-shell">
      <header className="auth-header">
        <Link className="auth-brand" to="/">
          <span className="brand-icon"><i className="bi bi-heart-pulse" aria-hidden="true" /></span>
          <strong>{branding?.site_name||appConfig.shortName}</strong>
        </Link>
        <button className="navbar-icon" type="button" onClick={() => setMode(resolvedTheme === 'dark' ? 'light' : 'dark')} aria-label="Toggle theme">
          <i className={`bi ${resolvedTheme === 'dark' ? 'bi-sun' : 'bi-moon-stars'}`} />
        </button>
      </header>
      <main className="auth-main"><Outlet /></main>
      <footer className="auth-footer">© {new Date().getFullYear()} {branding?.site_name||appConfig.name}. Your health information stays private.</footer>
    </div>
  )
}
